export function getUnnamedRfidDisplayLabel(rfidCode: string) {
    return `#${rfidCode.slice(-4)}`;
}

export function getRfidDisplayLabel(rfidCode: string, label?: string | null) {
    const trimmedLabel = label?.trim();

    if (trimmedLabel) {
        return trimmedLabel;
    }

    return getUnnamedRfidDisplayLabel(rfidCode);
}
